import Dot from './dot'

Dot.install = vue => {
  vue.component(Dot.name, Dot)
}

export default Dot
